import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="六个入口，六种梳理方式"
          description="同一段旧事，从人物、时间线或版本差异切入，会看到完全不同的侧面。先选一个入口，再决定往深处走多远。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-900"
            >
              查看全部栏目
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.key}
              to={`/topics?category=${encodeURIComponent(cat.name)}`}
              className={`group flex flex-col rounded-lg border p-6 transition-colors ${
                index === 0
                  ? 'border-primary-300 bg-primary-100 hover:border-primary-400'
                  : 'border-background-200 bg-background-100 hover:border-secondary-300'
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md ${
                    index === 0
                      ? 'bg-primary-700 text-background-50'
                      : 'bg-background-50 text-primary-700'
                  }`}
                >
                  <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-500">{cat.count} 条</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                进入栏目
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}